import React from "react";
import '../styles/components/Button.css'


function Button({text, onClick, style, image, link})
{
    console.log(image);

    if(link != '' && image != '')
    {
        return(
        <button className={style}>
            <a className="link" href={link} target="_blank">
                <img src={image} className="image"></img>
                <h1>{text}</h1>
            </a>
        </button>
        )
    }

    if(image == '')
    {
        return(
        <button onClick={onClick} className={style}>
            <h1>{text}</h1>
        </button>
        )
    }

    else
    {
        return(
        <button onClick={onClick} className={style}>
            <image src={image}></image>
            <h1>{text}</h1>
        </button>
        )
    }
    
}

export default Button;